import React, { useState } from "react";
import "./userdetails.css";
import User from "./User";
import { Route, BrowserRouter as Router, NavLink } from "react-router-dom";
import Doctor from "./Doctor";
import { Avatar, Button, IconButton } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Popover from "@material-ui/core/Popover";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  iconButtonAvatar: {
    padding: 4,
  },
  regHeader: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    zIndex: 1,
    backgroundColor: "#009be5",
    position: "fixed",
    height: "135px",
    top: "0px",
    left: "0px",
  },
  regHeaderCont: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    height: "max-content",
    padding: "10px",
    placeItems: "center",
  },
  typography: {
    padding: "16px 30px",
    display: "flex",
    flexDirection: "column",
    placeItems: "center",
  },
}));

const UserDetails = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const classes = useStyles();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <Router>
      <div className="userDetails">
        {/* <button onClick={props.logout}>logout</button> */}
        <div className="userDetails__container">
          <div style={{ width: "100%" }}>
            <NavLink
              to="/register/user"
              activeClassName="userDetails__btn__active"
            >
              <button class={`userDetails__btn`} style={{ width: "50%" }}>
                User
              </button>
            </NavLink>
            <NavLink
              to="/register/doctor"
              activeClassName="userDetails__btn__active"
            >
              <button class={`userDetails__btn`} style={{ width: "50%" }}>
                Doctor
              </button>
            </NavLink>
          </div>
          <Route path="/register/user">
            <User uid={props.uid} phno={props.phno} />
          </Route>
          <Route path="/register/doctor">
            <Doctor uid={props.uid} phno={props.phno} />
          </Route>
        </div>
      </div>
      <div className={classes.regHeader}>
        <div className={classes.regHeaderCont}>
          <Typography style={{ color: "white" }} variant="h5" component="h1">
            Register
          </Typography>
          <IconButton
            aria-describedby={id}
            color="inherit"
            className={classes.iconButtonAvatar}
            onClick={handleClick}
          >
            <Avatar src="/static/images/avatar/1.jpg" alt="" />
          </IconButton>
        </div>
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Typography className={classes.typography}>
          <Button
            className={classes.logout}
            style={{ backgroundColor: "#009be5", color: "white" }}
            variant="contained"
            onClick={props.logout}
          >
            Logout
          </Button>
        </Typography>
      </Popover>
    </Router>
  );
};

export default UserDetails;
